import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './style.css';
import Sidebar from '../Sidebar';
import Header from '../Header';
import BottomTabNavigator from '../BottomTabNavigator';

export default ({ authenticatedPage, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      {authenticatedPage ? (
        <>
          <Header />
          <Sidebar 
            isOpen={isSidebarOpen} 
            onClose={() => setIsSidebarOpen(false)} 
          />
          <div className="page-component" key={location.key}>
            {children}
          </div>
          <BottomTabNavigator 
            onMenuClick={() => setIsSidebarOpen(prev => !prev)} 
            isMenuOpen={isSidebarOpen}
          />
        </>
      ) : (
        <div className="page-component" key={location.key}>
          {children}
        </div>
      )}
    </>
  );
}
